<template>
    <v-sheet v-if="works.length" class="mt-30 mt-md-40 mt-md-50">
        <p class="font-size-md-42 font-size-36 line-height-1">Artworks</p>
        <!-- <v-card-title>Artworks</v-card-title> -->
        <v-row class="mt-20 mt-md-30 mt-lg-40">
            <template v-for="work in works">
                <v-col cols="12" md="3" :key="work._id">
                    <author-view-works-item v-bind="{ work }" />
                </v-col>
            </template>
        </v-row>
    </v-sheet>
</template>

<script>
import api from "@/api";
import authorViewWorksItem from "./author-view-works-item.vue";
export default {
    components: { authorViewWorksItem },
    props: {
        _author: { type: String, default: null },
    },
    data: () => ({
        works: [],

        loading: false,
    }),
    mounted() {
        this.init();
    },
    watch: {
        _author() {
            this.init();
        },
    },
    methods: {
        async init() {
            if (!this._author) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                const { _author } = this;
                const { works } = await api.v1.auction.works.gets({
                    params: { _author },
                });
                this.works = works;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>